import { observer } from 'src/utils/mobx-react';
import React, { useState } from 'react';
import { TypeId } from 'src_common/common/websocket2/type';
import { SelectionModel } from 'src_common/common/websocket2/models/SelectionModel/SelectionModel';
import { ParticipantModelType } from 'src_common/common/websocket2/modelsApi/Event';
import { EventMarketParticipantsFormState } from 'src/domains/sportsbook/trading/view/eventDetails/markets/eventMarketParticipantsForm/EventMarketParticipantsForm.state';
import { AddRemoveButton } from 'src/domains/sportsbook/trading/view/eventDetails/markets/eventMarketParticipantsForm/EventMarketpartcipantsForm.style';

export interface EventMarketParticipantsPropsType {
    marketId: TypeId.MarketId
    marketSelections: SelectionModel[]
    eventParticipants: Record<string, ParticipantModelType>
    onAddAllSelections: (eventId: number, marketId: number, participants: unknown) => void
    onSubmit: () => void
}

export const EventMarketParticipantsForm = observer('EventMarketParticipantsForm', (props: EventMarketParticipantsPropsType) => {
    const [state] = useState(() => new EventMarketParticipantsFormState(props));

    return (
        <div className='event-participants-form'>
            <input
                type='text'
                placeholder='Filter...'
                className='event-participants-form-filter'
                onChange={state.onSetFilter}
            />

            <section>
                <h4>Participants added</h4>

                <ul>
                    {
                        state.current.filter(state.filterParticipants).map(participant => (
                            <li key={participant.id + '-current'}>
                                {participant.name}
                            </li>))
                    }
                    {
                        state.chosen.filter(state.filterParticipants).map(participant => (
                            <li key={participant.id + '-chosen'}>
                                {participant.name}
                                <AddRemoveButton onClick={() => state.removeParticipant(participant)}>-</AddRemoveButton>
                            </li>
                        ))
                    }
                </ul>
            </section>
            <section>
                <div className='buttons'>
                    <button className='btn event-participants-form-save' onClick={state.submitConfirm}>
                            Confirm Selections
                    </button>
                    <button className='btn event-participants-form-save' onClick={state.submitAddAll}>
                            Add all selections
                    </button>
                </div>

                <h4>Add additional market participants</h4>

                <ul>
                    {state.available.filter(state.filterParticipants).map(participant => (
                        <li key={participant.id + '-available'}>
                            {participant.name}
                            <AddRemoveButton  onClick={() => state.addParticipant(participant)}>+</AddRemoveButton>
                        </li>
                    ))}
                </ul>
            </section>
        </div>
    );
});
